import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { withTracker, hitTypes } from 'helpers/tracking';
import getBase64Src from 'helpers/getBase64Src';
import Observer from 'react-intersection-observer';
import DefaultPromo from './DefaultPromo';
import SecondaryPromo from './SecondaryPromo';
import { DEFAULT_PROMO_VARIANT, SECONDARY_PROMO_VARIANT } from '../constants';

const promoTrackingLabels = {
  [DEFAULT_PROMO_VARIANT]: 'Ad List - Default Promo',
  [SECONDARY_PROMO_VARIANT]: 'Ad List - Secondary Promo',
};

class Promo extends PureComponent {
  static propTypes = {
    variant: PropTypes.oneOf([DEFAULT_PROMO_VARIANT, SECONDARY_PROMO_VARIANT]),
    tracker: PropTypes.object.isRequired,
    imageSource: PropTypes.string.isRequired,
  };

  static defaultProps = {
    variant: DEFAULT_PROMO_VARIANT,
  };

  state = {
    isIntersected: false,
  };

  handleObserver = (isIntersected) => {
    if (isIntersected) {
      this.setState({
        isIntersected: true,
      });
    }
  };

  trackPromoClick = () => {
    const { variant, tracker } = this.props;
    const label = promoTrackingLabels[variant];

    tracker.track(hitTypes.AD_PROMO_BANNER_CLICK, {
      label,
    });
  };

  render() {
    const { variant, imageSource, ...rest } = this.props;
    const { isIntersected } = this.state;

    const base64Pixel =
      'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';
    const promoProps = {
      imageSource: isIntersected ? imageSource : getBase64Src(base64Pixel),
      ...rest,
    };

    return (
      <Observer
        threshold={0}
        rootMargin="0px 0px 200px 0px"
        onChange={this.handleObserver}
      >
        {variant === SECONDARY_PROMO_VARIANT ? (
          <SecondaryPromo {...promoProps} onClick={this.trackPromoClick} />
        ) : (
          <DefaultPromo {...promoProps} onClick={this.trackPromoClick} />
        )}
      </Observer>
    );
  }
}

export default withTracker(Promo);
